/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { IPromoBannerViewProps } from '@msdyn365-commerce-modules/promo-banner/dist/types';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IPromoBannerProps } from '../definition-extensions/promo-banner.ext.props.autogenerated';
const PromoBannerView: React.FC<IPromoBannerViewProps & IPromoBannerProps<{}>> = props => {
    const { promoBannerProps, contentProps, closeButton, bannerMessages, config, promoBannerTextProps, carouselProps } = props;

    const helpLink = config.helpLink;

    const slides =
        bannerMessages &&
        bannerMessages.map((message, index) => {
            const link = message.links && message.links.length > 0 ? message.links[0].linkUrl : undefined;
            return (
                <Node {...contentProps} key={index}>
                    {link && (
                        <div>
                            <a href={link.destinationUrl}>{message.text && <Node {...promoBannerTextProps} text={message.text} />}</a>
                        </div>
                    )}
                    {!link && message.text && <Node {...promoBannerTextProps} text={message.text} />}
                </Node>
            );
        });

    if (bannerMessages.length === 0) {
        return null;
    }

    return (
        <Module {...promoBannerProps}>
            <div className='col-12'>
                <div className='row'>
                    <div className='col-md-3' />
                    <div className='col-md-6'>
                        <Node {...carouselProps} items={slides} />
                    </div>
                    <div className='col-md-3 custom-promo-wrap'>
                        {helpLink && helpLink.linkText && (
                            <a href={helpLink.linkUrl.destinationUrl}>
                                <span className='ms-promo-banner__text'>{helpLink.linkText}</span>
                            </a>
                        )}
                        {closeButton}
                    </div>
                </div>
            </div>
        </Module>
    );
};
export default PromoBannerView;
